import { useEffect, MutableRefObject } from "react";

type Props = {
  ref: MutableRefObject<any>;
  onClickOutside: () => void;
};

const useOutsideClick = ({ ref, onClickOutside }: Props) => {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClickOutside();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onClickOutside]);
};

export default useOutsideClick;
